<template>
  <div>
    <DeviceCalibration :deviceId="deviceId" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DeviceCalibration from '@/components/widgets/currentReadings/content/DeviceCalibration.vue'

export default defineComponent({
  name: 'ContinuousMonitoringAndStudyFooter',
  components: {
    DeviceCalibration
  },
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  }
})
</script>
